<template>
  <div
    class="zmm-video">
    <div class="default-container">
      <div
        v-if="typeof player !== 'undefined'"
        class="zmm-video__fake-overlay"
        @click="$_playPause">
        <div
          v-if="!playing"
          class="zmm-video__fake-overlay--play"><span>PLAY</span></div>

        <div
          v-else
          class="zmm-video__fake-overlay--pause"><span>PAUSE</span></div>
      </div>

      <div
        v-video="playerOptions"
        class="zmm-video__video"></div>
    </div>
  </div>
</template>

<script>
import YouTubePlayer from 'youtube-player'

export default {
  data: () => ({
    player: undefined,
    playing: false,
    statuses: {
      PLAYING: 1
    }
  }),
  props: {
    videoId: {
      type: String,
      default: 'tlTKTTt47WE'
    }
  },
  computed: {
    playerOptions: {
      get () {
        return {
          videoId: this.videoId,
          playerVars: {
            autoplay: 0,
            controls: 0,
            fs: 0,
            modestbranding: 1,
            rel: 0,
            showinfo: 0
          }
        }
      }
    }
  },
  methods: {
    async $_playPause () {
      if (await this.player.getPlayerState() !== this.statuses.PLAYING) this.player.playVideo()
      else this.player.pauseVideo()
    },
    async $_refreshMobileButtons () {
      this.playing = await this.player.getPlayerState() === this.statuses.PLAYING
    }
  },
  directives: {
    video: {
      bind (el, binding, vnode) {
        vnode.context.$data.player = YouTubePlayer(el, binding.value)
        vnode.context.$data.player.on('stateChange', vnode.context.$_refreshMobileButtons)
      },
      unbind (el, binding, vnode) {
        // TODO: update
        vnode.context.$data.player.destroy()
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";

.zmm-video{
  padding: 3rem 0 5rem;
  background-color: #1d1d1b;
}

.zmm-video__fake-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;

  .zmm-video__fake-overlay--pause {
      opacity: 0;
      transition: opacity .3 ease-in-out;
    }

  &:hover {
    .zmm-video__fake-overlay--pause {
      opacity: 1;
    }
  }
}

.zmm-video__fake-overlay--play, .zmm-video__fake-overlay--pause {
  background: rgba($color: #4A4A4A, $alpha: .5);
  width: 75px;
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #EFEFF1;
  font-weight: 500;
  font-size: 1.4rem;

  @media #{$xlarge_mq} {
    font-size: 1.6rem;
    width: 100px;
    height: 100px;
  }

}

.zmm-video iframe{
  width: 100%;
  height: calc(315px * (100vw - 52px) / 560);
  max-width: 100%;

  @media #{$large_mq} {
    height: calc(315px * 900 / 560);
  }
  @media #{$xlarge_mq} {
    height: calc(315px * 1260 / 560);
  }
  @media #{$xxlarge_mq} {
    height: calc(315px * 1440 / 560);
  }

}

</style>
